<form [formGroup]="searchForm" (ngSubmit)="onSearch()">
  <div class="d-flex flex-wrap" data-test-id="wrap-search-input-field">
    <div class="col-md-3 mb-2 me-2 min-w-350p">
      <label for="search-field" class="form-label sr-only">
        {{ 'SEARCH_FIELDS_SEARCH_BTN_HINT' | translate }}
      </label>
      <input
        type="text"
        class="form-control"
        formControlName="inputField"
        id="search-input-field"
        data-test-id="search-input-field"
        placeholder="{{ 'SEARCH_FIELDS_SEARCH_INPUT_HINT' | translate }}"
      />
    </div>
    <div>
      <button data-test-id="search-submit-btn" type="submit" class="btn btn-primary ms-1 mb-2">
        {{ 'SEARCH_FIELDS_SEARCH_BTN_HINT' | translate }}
      </button>
    </div>
  </div>
  <div class="d-flex flex-wrap">
    <div class="mb-3 w-100">
      <div class="row col-md-8">
        <div class="col-md-10 col-lg-9 col-xl-8">
          <app-select-form-field [attr]="attr" [searchForm]="searchForm" (searchValue)="setCategoriesValue($event)">
          </app-select-form-field>
        </div>
      </div>
    </div>
  </div>
</form>
